exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YAwFxF1oxeQEESgseJfZv .dnn-grid-cell {\n  overflow-wrap: break-word;\n}\n._3YAwFxF1oxeQEESgseJfZv .dnn-grid-cell.no-users {\n  float: left;\n  width: 100%;\n  text-align: center;\n  padding: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"usersList": "_3YAwFxF1oxeQEESgseJfZv"
};